"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVALID_RUN_ID = void 0;
exports.INVALID_RUN_ID = '#invalid-run-id';
